import Vue, { VNode } from "vue";

import { prevent } from "../utils/prevent";

export interface DragDetail {
  direction: "horizontal" | "vertical" | "";
  deltaX: number;
  deltaY: number;
  offsetX: number;
  offsetY: number;
}

Vue.directive("drag", {
  inserted(el, binding, vnode: VNode) {
    let direction: "horizontal" | "vertical" | "" = "";
    let deltaX = 0;
    let deltaY = 0;
    let offsetX = 0;
    let offsetY = 0;
    let startX = 0;
    let startY = 0;
    const dragEvent = new CustomEvent<DragDetail>("drag", {
      detail: {
        direction,
        deltaX,
        deltaY,
        offsetX,
        offsetY,
      },
    });
    const dragEndEvent = new CustomEvent("dragEnd");

    el.addEventListener("touchstart", (event: Event) => {
      resetTouchStatus();
      startX = (event as TouchEvent).touches[0].clientX;
      startY = (event as TouchEvent).touches[0].clientY;
    });

    el.addEventListener("touchmove", (event: Event) => {
      const touch = (event as TouchEvent).touches[0];
      deltaX = touch.clientX - startX;
      deltaY = touch.clientY - startY;
      offsetX = Math.abs(deltaX);
      offsetY = Math.abs(deltaY);
      direction =
        offsetX > offsetY ? "horizontal" : offsetX < offsetY ? "vertical" : "";

      Object.assign(dragEvent.detail, {
        direction,
        deltaX,
        deltaY,
        offsetX,
        offsetY,
      });
      el.dispatchEvent(dragEvent);
      prevent(event);
    });

    el.addEventListener("touchend", () => el.dispatchEvent(dragEndEvent));
    el.addEventListener("touchcancel", () => el.dispatchEvent(dragEndEvent));

    function resetTouchStatus() {
      direction = "";
      deltaX = 0;
      deltaY = 0;
      offsetX = 0;
      offsetY = 0;
    }
  },
});
